import { render, staticRenderFns } from "./KinvaItemSelect.vue?vue&type=template&id=cd87c85a&scoped=true"
import script from "./KinvaItemSelect.vue?vue&type=script&lang=js"
export * from "./KinvaItemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd87c85a",
  null
  
)

export default component.exports